import React from "react";
import { MdOutlineCalendarMonth } from "react-icons/md";

function Education({ title, subTitle, date, reverse,height }) {
  return (
    <div className={` flex ${reverse} justify-between `}>
      <div className="border-0 border-black w-[50%]">
        <h1 className="font-semibold">{title} </h1>
        <p className="font-medium text-gray-700 text-[0.8rem] pb-[10px]">{subTitle}</p>
        <p className="mt-[5px] flex items-center gap-2">
          <span>
            <MdOutlineCalendarMonth />
          </span>
          {date}
        </p>
      </div>
      {/* <div className="w-[48%] border border-red-500"></div> */}
      <div className={`w-0.5 mx-[25px] ${height} bg-gray-700 relative flex justify-center`}>
        <p className="w-[20px] h-[20px] -top-1 rounded-full absolute bg-gray-700"></p>
      </div>
      <div className="w-[50%]"></div>
    </div>
  );
}

export default Education;
